import type { Country } from 'commons/constants/countries'
import type { InputProps } from '@chakra-ui/react'
import { Input } from '@chakra-ui/react'
import { formatDisplay } from 'commons/utils/phoneHelpers'
import { sanitize } from 'commons/utils/phoneHelpers'
import { useState, type ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
	country: Country
}

export const PhoneInput = ({ country, ...rest }: InputProps & Props) => {
	const [raw, setRaw] = useState<string>('')
	const [isFocused, setIsFocused] = useState<boolean>(false)
	const { t } = useTranslation()

	return (
		<Input
			fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
			fontWeight={500}
			id='tel'
			autoComplete='tel'
			name='tel'
			size='md'
			pl={2}
			py={2}
			type='tel'
			variant='unstyled'
			_focus={{ outline: 'none' }}
			_focusVisible={{ outline: 'none' }}
			value={isFocused ? raw : formatDisplay(raw, country.iso)}
			placeholder={t('phone_form.phone_placeholder')}
			onChange={(e: ChangeEvent<HTMLInputElement>) => {
				setRaw(sanitize(e.target.value))
				rest.onChange?.(e)
			}}
			onFocus={() => setIsFocused(true)}
			onBlur={() => setIsFocused(false)}
		/>
	)
}
